import { PlayerTrack } from '@/types/track_types';
import { logger } from '@/utils/logger';

const PLAY_HISTORY_KEY = 'nowPlayingTracks';
const MAX_HISTORY_SIZE = 100; // 최대 100곡까지 저장

/**
 * 세션 스토리지에서 재생 기록 가져오기
 */
export function getPlayHistory(): PlayerTrack[] {
  try {
    const history = sessionStorage.getItem(PLAY_HISTORY_KEY);
    if (!history) return [];
    return JSON.parse(history) as PlayerTrack[];
  } catch (error) {
    logger.error('Failed to load play history from session storage:', error);
    return [];
  }
}

/**
 * 세션 스토리지에 재생 기록 저장하기
 */
export function savePlayHistory(tracks: PlayerTrack[]): void {
  try {
    sessionStorage.setItem(PLAY_HISTORY_KEY, JSON.stringify(tracks));
  } catch (error) {
    logger.error('Failed to save play history to session storage:', error);
  }
}

/**
 * 재생한 트랙을 히스토리에 추가
 * - 같은 트랙이 이미 있으면 제거하고 최상단에 추가
 * - 최대 개수를 초과하면 가장 오래된 항목 제거
 */
export function addTrackToHistory(track: PlayerTrack): void {
  try {
    const history = getPlayHistory();

    // 중복 제거 (같은 id를 가진 트랙 제거)
    const filteredHistory = history.filter(t => t.id !== track.id);

    // 새 트랙을 맨 앞에 추가
    const newHistory = [track, ...filteredHistory];

    // 최대 개수 제한
    const limitedHistory = newHistory.slice(0, MAX_HISTORY_SIZE);

    savePlayHistory(limitedHistory);
  } catch (error) {
    logger.error('Failed to add track to history:', error);
  }
}

/**
 * 재생 기록 초기화
 */
export function clearPlayHistory(): void {
  try {
    sessionStorage.removeItem(PLAY_HISTORY_KEY);
  } catch (error) {
    logger.error('Failed to clear play history:', error);
  }
}

/**
 * 재생 기록 개수 가져오기
 */
export function getPlayHistoryCount(): number {
  return getPlayHistory().length;
}
